import React from 'react';
import {
  Button,
  Switch,
  Input,
  FormControl,
  FormLabel,
  VStack,
} from '@chakra-ui/react';
import { getRandomInt } from './Mathround';
const seedrandom = require('seedrandom');

class Settings extends React.Component {
  state = {
    planetSeed: this.props.redux.planet.seed,
    terrainSeed: this.props.redux.terrain.seed,
  };

  handleClose = () => {
    const { redux } = this.props;
    redux.toggleSettingsPopupAction(false);
  };

  handleChange = (event) => {
    const { settings } = this.props.redux;
    this.props.redux.updateSettingsAction({
      ...settings,
      autoSave: event.target.checked,
    });
  };

  handlePlanetSeedChange = (event) => {
    const { planet } = this.props.redux;
    this.props.redux.generateStartLocationAction({
      ...planet,
      seed: event.target.value,
      terrains: [],
    });
  };

  generateNewPlanetSeed = () => {
    const { planet } = this.props.redux;
    this.props.redux.generateStartLocationAction({
      ...planet,
      seed: seedrandom(getRandomInt(1, 100000000000))() * 100000000000000000,
      terrains: [],
    });
  };

  clearLocalStorage = (event) => {
    event.preventDefault();
    localStorage.clear('gameData');
    window.location.reload();
  };

  render() {
    const { redux } = this.props;
    return (
      <>
        <VStack mt={4}>
          <Button onClick={this.generateStartLocation}>
            Get start location
          </Button>
          <FormControl display="flex" alignItems="center">
            <Input
              id="planetSeed"
              label="Planet seed"
              type="text"
              w={200}
              value={redux.planet.seed}
              onChange={this.handlePlanetSeedChange}
            />
            <Button onClick={this.generateNewPlanetSeed} w={200}>
              Generate new planet
            </Button>
          </FormControl>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <FormLabel mb="0" htmlFor="autosave">
              Autosave
            </FormLabel>
            <Switch
              id="autosave"
              defaultChecked={this.props.redux.settings.autoSave}
              onChange={this.handleChange}
              value="autosave"
              color="primary"
            />
          </FormControl>
          <Button color="secondary" onClick={this.clearLocalStorage}>
            Clear saved game
          </Button>
        </VStack>
      </>
    );
  }
}

export { Settings };
